<template lang="html">
  <div class="shopify-create-store">
    <Guide
      width="small"
      :content="content"
      contentHeading="Create a Google Account"
      :closeLink="closeLink"
      :nextLink="nextLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'AnalyticsCreateGoogleAccount',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'analytics-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'analytics-create-analytics-account',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p><strong>A Google Account gives you access to many Google products.</strong></p>

          <p>If you've signed in to any Google product before (like <a href="https://gmail.com" target="_blank">Gmail</a>, <a href="https://google.com/maps" target="_blank">Maps</a>, or <a href="https://youtube.com" target="_blank">YouTube</a>), you already have a Google Account. You can use the same username and password you created for that product to sign in to any other Google products, such as <a href="https://analytics.google.com/analytics" target="_blank">Google Analytics</a>.</p>

          <p>If you don't have an account, create a free <a href="https://accounts.google.com/signup/v2/webcreateaccount?flowName=GlifWebSignIn&flowEntry=SignUp" target="_blank">Google Account</a> to get started.</p>

          <p>Once you have created your Google account, go to your <a href="https://analytics.google.com/analytics/web/" target="_blank">Google Analytics</a> dashboard.</p>
        `
    },

    contentVideo() {
      return 'https://cdn.shopify.com/assets2/home/manage-animation-a9cecf49c4414fd02d9fa00482fd30e436fc373208255d90d92491be650b8d13.mp4'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
